export const featuredStories = [
  {
    id: 1,
    title: "OpenAI Unveils New AI Model – What's New?",
    category: "AI NEWS",
    date: "May 18, 2024",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&q=80&w=600",
  },
  {
    id: 2,
    title: "10 AI Tools That Will Supercharge Your Work",
    category: "TECH",
    date: "May 17, 2024",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1680792563719-288027b2a090?auto=format&fit=crop&q=80&w=600",
  },
  {
    id: 3,
    title: "The Future of AI: Predictions for 2025",
    category: "INSIGHTS",
    date: "May 16, 2024",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?auto=format&fit=crop&q=80&w=600",
  }
];

export const latestArticles = [
  {
    id: 4,
    title: "Meta Introduces Llama 3 – The Next Generation AI Model",
    excerpt: "Meta's latest AI model Llama 3 is faster, smarter and more powerful. Here's everything you need to know.",
    category: "AI NEWS",
    date: "May 18, 2024",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?auto=format&fit=crop&q=80&w=800",
  },
  {
    id: 5,
    title: "Top 7 Chrome Extensions for Productivity in 2024",
    excerpt: "Supercharge your productivity with these must-have Chrome extensions.",
    category: "TECH",
    date: "May 17, 2024",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=800",
  },
  {
    id: 6,
    title: "Best AI Tools for Content Creators",
    excerpt: "These AI tools will help content creators create better content, faster and smarter.",
    category: "AI TOOLS",
    date: "May 17, 2024",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=800",
  }
];

export const trendingNow = [
  {
    id: 7,
    title: "Google I/O 2024: All Major Announcements",
    date: "May 18, 2024",
    image: "https://images.unsplash.com/photo-1573164713988-8665fc963095?auto=format&fit=crop&q=80&w=200",
  },
  {
    id: 8,
    title: "Best AI Writing Tools for Bloggers",
    date: "May 17, 2024",
    image: "https://images.unsplash.com/photo-1499750310107-5fef28a66643?auto=format&fit=crop&q=80&w=200",
  },
  {
    id: 9,
    title: "How to Make Money with AI in 2024",
    date: "May 16, 2024",
    image: "https://images.unsplash.com/photo-1639762681485-074b7f438a5b?auto=format&fit=crop&q=80&w=200",
  },
  {
    id: 10,
    title: "Midjourney v6 is Here – Full Features",
    date: "May 15, 2024",
    image: "https://images.unsplash.com/photo-1682687220063-474237cff6b7?auto=format&fit=crop&q=80&w=200",
  }
];

export const exploreCategories = [
  { name: "AI News", count: 0, icon: "Zap" },
  { name: "Tech", count: 0, icon: "Cpu" },
  { name: "AI Tools", count: 0, icon: "Wrench" },
  { name: "Business", count: 0, icon: "Briefcase" },
  { name: "Blogging", count: 0, icon: "FileText" },
  { name: "Automation", count: 0, icon: "Rocket" }
];
